var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1436_4669",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0390625,
    y: 0.481445,
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1436_4669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9341 17.4604C14.2535 17.3354 12.6598 16.9223 11.1528 16.2209C9.64589 15.5195 8.2952 14.5716 7.10075 13.3771C5.90631 12.1827 4.96186 10.832 4.26742 9.32503C3.57298 7.81809 3.16325 6.22434 3.03825 4.54378C3.01048 4.25212 3.09728 3.99864 3.29867 3.78337C3.50006 3.56809 3.74659 3.46045 4.03825 3.46045H6.87159C7.1077 3.46045 7.31256 3.53337 7.48617 3.6792C7.65978 3.82503 7.77437 4.00906 7.82992 4.23128L8.32992 6.46045C8.3577 6.641 8.34728 6.81462 8.29867 6.98128C8.25006 7.14795 8.1702 7.28684 8.05909 7.39795L6.03825 9.43962C6.31603 9.96739 6.63548 10.4743 6.99659 10.9604C7.3577 11.4466 7.76048 11.9049 8.20492 12.3354C8.62159 12.7521 9.06603 13.1375 9.53825 13.4917C10.0105 13.8459 10.5105 14.1618 11.0383 14.4396L13.1008 12.4396C13.2119 12.3285 13.3508 12.2486 13.5174 12.2C13.6841 12.1514 13.8577 12.141 14.0383 12.1688L16.2674 12.6479C16.5035 12.7174 16.691 12.8389 16.8299 13.0125C16.9688 13.1861 17.0383 13.391 17.0383 13.6271V16.4604C17.0383 16.7521 16.9271 16.9986 16.7049 17.2C16.4827 17.4014 16.2258 17.4882 15.9341 17.4604Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.80ad8d577ac30c312626edd0440fa404.svg";
export { ForwardRef as ReactComponent };